import { images } from "../constants";
import {
  WhySectionBubble,
  WhySectionBubbleAccent,
  WhySectionBubbleText,
  WhySectionCard,
  WhySectionCardImage,
  WhySectionCardList,
  WhySectionCardText,
  WhySectionCardTitle,
  WhySectionRoot,
} from "../styles";

export default function WhySection() {
  return (
    <WhySectionRoot>
      <WhySectionBubble $backgroundImage={images.whyBubble}>
        <WhySectionBubbleText>
          <span>なぜ、手間をかけずに</span>
          <span>
            「<WhySectionBubbleAccent>最高値</WhySectionBubbleAccent>」で売れるのか？
          </span>
        </WhySectionBubbleText>
      </WhySectionBubble>

      <WhySectionCardList>
        <WhySectionCard $flushRight>
          <WhySectionCardTitle>❶ 投資用マンションに特化</WhySectionCardTitle>
          <WhySectionCardImage src={images.whySpecialization} alt="投資用マンションに特化" />
          <WhySectionCardText>
            居住用物件を扱う会社ではなく、投資ワンルームの「出口」に強い専門会社だけを厳選。空室リスクや利回りを加味した、最も高い評価額を引き出します。
          </WhySectionCardText>
        </WhySectionCard>

        <WhySectionCard $flushLeft>
          <WhySectionCardTitle>❷ 20社のプロが価格を競い合う</WhySectionCardTitle>
          <WhySectionCardImage src={images.whyCompetition} alt="20社のプロが価格を競い合う" />
          <WhySectionCardText>
            20社が同時に査定を行うため、自然と競争が発生します。他社に負けないための「限界価格」が最初から提示されるため、交渉なしで最高値が手に入ります。
          </WhySectionCardText>
        </WhySectionCard>
      </WhySectionCardList>
    </WhySectionRoot>
  );
}
